import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExamiframeComponent } from '../examiframe/examiframe.component';
import { LoadingdivComponent } from '../loadingdiv/loadingdiv.component';
import { ProcteevideomodalComponent } from '../procteevideomodal/procteevideomodal.component';
import { MeetingHandlerService, NotificationMessages } from '../services/meeting-handler.service';
import { MeetingService } from '../services/meeting.service';
import { ProctorService } from '../services/proctor.service';
import { UtilService } from '../services/util.service';
import { AIFlags, AIPreventExamStartResponse, AiProctorService } from '../services/aiproctor.service';
import { WebcamaccessnotificationdivComponent } from '../webcamaccessnotificationdiv/webcamaccessnotificationdiv.component';
import { environment } from 'src/environments/environment';
import { Participant } from '../models/Participant';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { ChatmodalComponent } from '../chatmodal/chatmodal.component';
import { SecondViewIframeComponent } from '../second-view-iframe/second-view-iframe.component';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { of } from 'rxjs';
declare const SafeExamBrowser;
declare const $: any;

@Component({
  selector: 'app-proctor',
  templateUrl: './app-proctor.component.html',
  styleUrls: ['./app-proctor.component.css']
})
export class ProctorComponent implements OnInit, AfterViewInit {

  title = 'proctee';
  passportBlob: any;

  

  @ViewChild('loadingDivComponent') loadingDivComponent!: LoadingdivComponent;
  @ViewChild('examIframeComponent') examIframeComponent!: ExamiframeComponent;
  @ViewChild('webcamAccessNotificationDivComponent') webcamAccessNotificationDivComponent: WebcamaccessnotificationdivComponent;
  @ViewChild('secondViewIframeComponent') secondViewIframeComponent: SecondViewIframeComponent;

  isMacUser: boolean = false;
  showQuitButton: boolean = false;
  proctorStartClicked: boolean = false;
  isUsingExternalExamUrl: boolean = false;
  proctorStarted = false;

  seb: string;
  
  private mediaTestModalRef: NgbModalRef | undefined;
  
  

  constructor(private proctorService: ProctorService, private meetingHandlerService: MeetingHandlerService,
    private aiProctorService: AiProctorService, private meetingService: MeetingService, private toastr: ToastrService, private util: UtilService, private modalService: NgbModal) {
  }

  @HostListener('window:beforeunload', [ '$event' ])
  beforeUnloadHandler(event) {
    //return false;
    //console.log(`visibility state: ${document.visibilityState}`);
    //if (document.visibilityState === 'hidden') {
      this.meetingService.selfDisconnectAndDeassign(this.meetingHandlerService.domain, this.meetingHandlerService.jwt, this.meetingHandlerService.clientInstanceId, true);
      
      //calling this shouldn't be necessary because the server already does it. However, for insurance...
      this.meetingService.deassignMeetingServer(this.meetingHandlerService.meetingid, this.meetingHandlerService.jwt, this.meetingHandlerService.clientInstanceId, true);
    //}
    
    // if(this.meetingHandler.usersIncremented){
    //   this.meetingservice.decrementUsers(this.meetingHandler.meetingid, this.meetingHandler.jwt).toPromise();//no need to await
  // }
  }

  async ngAfterViewInit() {
    this.proctorService.secondViewIframeComponent = this.secondViewIframeComponent;
    this.proctorService.examIframeComponent = this.examIframeComponent;

    console.log(`company set to ${this.proctorService.company}`);

    window.addEventListener('message', async (evt) => {
      //console.log(evt.data);
      const messageid = evt.data.messageid;
      if (!messageid) {
        console.error(new Error('messageid not set'));
        return;
      }
      const ret: any = { messageid: messageid };

      try {
        if (evt.data.operation === 'start') {
          console.log('called start - ');
          await this.proctorService.startProctoringEventHandler(evt.data);

          if (this.proctorService.prevenstart?.preventstart) {
            ret.message = "aipreventstart";
            ret.reasons = this.proctorService.prevenstart.reasons;
          }
        }
        else if (evt.data.operation === 'stop') {
          

          await this.proctorService.stopProctorEventHandler(evt.data);
          //ret.status = 'done';
        }
        else if (evt.data.operation === 'checkpublishing') {
          if (this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctoredOnly || this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist) {
            //the minimum requirement should be recording
            ret.publishing = this.proctorService.recording(); //this.proctorService.producing('video') && this.proctorService.producing('audio') && this.proctorService.recording();
          }
          else if (this.proctorService.proctorInfo.proctorLevel == ProctorLevels.RecordOnly || this.proctorService.proctorInfo.proctorLevel == ProctorLevels.AiProctoredOnly) {
            ret.publishing = this.proctorService.recording();
          }
          else {
            ret.publishing = false;
          }
        }
        else if(evt.data.operation === 'getdualviewpreference'){
          ret.preference = this.proctorService.secondViewPreference;
        }
        else if (evt.data.operation === 'loading') {
          console.log('loading...');
          // let loadingdiv = document.getElementById('loadingdiv');
          // loadingdiv.style.display = 'block';
          this.loadingDivComponent.loading = true;
        }
        else if (evt.data.operation === 'loaded') {
          console.log('loaded');
          // let loadingdiv = document.getElementById('loadingdiv');
          // loadingdiv.style.display = 'none';
          this.loadingDivComponent.loading = false;
        }
        else if (evt.data.operation === 'procteetestvideo') {
          this.mediaTestModalRef = this.modalService.open(
            ProcteevideomodalComponent, {
              backdrop: 'static',
              keyboard: false,
              size: 'lg',
              centered: true,
            }
          );
        }
        else if (evt.data.operation === 'raisehand') {
          await this.meetingHandlerService.raiseHand();
        }
        else if (evt.data.operation === 'setcountdowntimer') {
          //'Proctor_' + socket.id
          if ((this.proctorService.proctorInfo && (this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctoredOnly || this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist)) && this.meetingHandlerService.connected) {
            //if we are not in the default room, then it means we are in a proctor's room
            this.proctorService.sendCustomPrivateMessageToProctor('setCountdownTimer', { remoteId: this.meetingHandlerService.clientInstanceId, timeleft: evt.data.timeleft });
          }
          //await sendMediasoupControlRequest('setCountdownTimer', { username: socket.id, timeleft: evt.data.timeleft });
        }
        else if (evt.data.operation === 'setproctorpausestatus') {
          if ((this.proctorService.proctorInfo && (this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctoredOnly || this.proctorService.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist)) && this.meetingHandlerService.connected) {
            this.proctorService.sendCustomPrivateMessageToProctor('setProctorPauseStatus', { remoteId: this.meetingHandlerService.clientInstanceId, proctorpaused: evt.data.proctorpaused, adminpaused: evt.data.adminpaused, pausereason: evt.data.pausereason });
          }
        }
        else if (evt.data.operation === 'quitseb') {
          this.quitseb();
        }
        // else if (evt.data.operation === 'hidesebpb') {
        //   this.showsebpb = false;
        // }
        // else if(evt.data.operation === 'getlastvideouploaddetails'){
        //   ret.lastVideoUploadedRecordingTime = this.proctorService.lastVideoUploadedRecordingTime;
        //   ret.lastVideoUploadedPart = this.proctorService.lastVideoUploadedPart;
        // }
        else if(evt.data.operation === 'getsebkey'){
          const key = this.seb;
          ret.configKey = key;
        }
        // else if(evt.data.operation === 'getsebkeymachinemacaddresses'){
        //   ret.macAddresses = SafeExamBrowser?.security?.macAddresses ?? '';
        // }
        // else if(evt.data.operation === 'getsebversion'){
        //   ret.sebVersion = SafeExamBrowser?.version ?? '';
        // }
        ret.success = true;
      }
      catch (error) {
        console.error(error);
        ret.success = false;
        ret.message = error?.message ?? error;
      }
      this.examIframeComponent.examIframe.nativeElement.contentWindow.postMessage(ret, '*');
    });

    await this.loadExamIframe();
  }

  quitseb() {
    window.location.href = environment.quitseburl;
  }

  async ngOnInit() {
    //const urlParams = new URLSearchParams(window.location.search);
    //debugger
    if(!this.seb && typeof SafeExamBrowser !== 'undefined'){
      this.seb = SafeExamBrowser?.security?.configKey;
    }
    this.isMacUser = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    this.showQuitButton = this.seb && this.isMacUser;

    const urlParams = new URLSearchParams(window.location.search);

    if(urlParams.has('externalexamurl')){
      this.isUsingExternalExamUrl = true;
    }
  }

  

  

  

  async loadExamIframe(fromClick: boolean = false) {
    if (this.proctorService.company) {
      try {    
        const urlParams = new URLSearchParams(window.location.search);
        
        this.proctorStartClicked = true;
        let isUsingExternalExamUrl = false;
        const examurl = await this.proctorService.getExamUrl();

        if (examurl && examurl.url) {
          


          
          //debugger
          let passthroughquery = '';
          let seb = '';
          if (urlParams.has('passthroughquery')) {
            passthroughquery = urlParams.get('passthroughquery');
          }
          if (urlParams.has('seb')) {
            seb = urlParams.get('seb');
          }
          let iframeurl = examurl.url;

          if(urlParams.has('externalexamurl')){
            iframeurl = urlParams.get('externalexamurl');
            isUsingExternalExamUrl = true;
          }

          if (passthroughquery) {
            if (!iframeurl.includes('?')) {
              iframeurl += '?';
            }
            else {
              iframeurl += '&';
            }
            iframeurl += passthroughquery;
          }
          if (seb) {
            if (!iframeurl.includes('?')) {
              iframeurl += '?';
            }
            else {
              iframeurl += '&';
            }
            iframeurl += "seb=" + seb;
          }
          this.proctorService.examUrl = iframeurl;

          

          //it seems like the seb config file generator is converting urls with & into &amp; so we're accounting for that
          if(isUsingExternalExamUrl && (urlParams.has('startproctordatajson') || urlParams.has('amp;startproctordatajson'))){
            if(!fromClick){
              return;
            }

            try {
              await this.proctorService.getVideoStream(true);
            }
            catch (error) {
              console.error(error);
              alert('Unable to acquire video stream.');
              return;
            }
            //if we're using an external exam url, it is assumed there is no proper integration, so we'll automatically start proctoring
            const startProctorDataJson = urlParams.get('startproctordatajson') ?? urlParams.get('amp;startproctordatajson');

            const _data = JSON.parse(startProctorDataJson);

            const exam = _data.exam;
            const user = _data.user;
            const overrideAIPassportCheck = _data.overrideAIPassportCheck;
            

            const autoStartProctor = async (username, name, examid, examdesc, examscheduleid, attempt, passportversion, passporttype, skipAIPassportCheck, allowExternalPrimaryWebcam, allowExternalSecondViewWebcam, secondViewRequired) => {
              skipAIPassportCheck = skipAIPassportCheck || overrideAIPassportCheck;

              const data = {operation: 'start',
                            username: username,
                            name: name + ` (${examdesc})`,
                            examid: examid,
                            examdesc: examdesc,
                            attempt: attempt,
                            //overrideai: !overrideSchedulePreventExamStart.msg,
                            passportversion: passportversion,
                            passporttype: passporttype,
                            aiCheckPhotoBeforeStart: passportversion > 0 && !skipAIPassportCheck,
                            scheduleid: examscheduleid,
                            allowExternalPrimaryWebcam: allowExternalPrimaryWebcam,
                            allowExternalSecondViewWebcam: allowExternalSecondViewWebcam,
                            secondViewRequired: secondViewRequired,
                            startSecondViewProctor: secondViewRequired
                          };
              
              await this.proctorService.startProctoringEventHandler(data);

              if(this.proctorService.prevenstart?.preventstart){
                await this.proctorService.stopProctorEventHandler({...data});

                throw new Error(`Proctor Start Prevented. Reason: ${this.proctorService.prevenstart?.reasons[0]}`);
              }
            };
            this.proctorStarted = true;
            // this.examIframeComponent.examIframe.nativeElement.src = 'https://gtb-recruitment.webtest.ng/please-wait';
            this.examIframeComponent.examIframe.nativeElement.src = window.location.origin + '/please-wait';
            // this.showPleaseWait = true;
            this.examIframeComponent.examIframe.nativeElement.style.display = 'block';
            this.webcamAccessNotificationDivComponent.webcamAccessNotificationDiv.nativeElement.style.display = 'none';
            try
            {
              
              await autoStartProctor(user.username, 
                                          user.fullname, 
                                          exam.examid, 
                                          exam.name, 
                                          exam.scheduleid, 
                                          exam.attempt, 
                                          user.imageversion, 
                                          user.imagetype,
                                          exam.skipAIPassportCheck || user.skipaifacematching,
                                          exam.allowExternalPrimaryWebcam,
                                          exam.allowExternalSecondViewWebcam,
                                          exam.requiresecondview);
            }
            catch(error){
              console.error(error);
              this.proctorService.stopProctorEventHandler({ operation: 'stop', reason: error?.message || 'External exam start error' });
              const errorMessage = error?.message || 'Unable to connect to proctoring system. Please check your internet connection and try again later';
              window.frames[0].postMessage({ type: 'proctorError', error: errorMessage }, '*');
              return;
            }
          }
          else{
            try {
              await this.proctorService.getVideoStream(true);
            }
            catch (error) {
              console.error(error);
              alert('Unable to acquire video stream.');
              return;
            }
          }
          // this.showPleaseWait = false;
          this.examIframeComponent.examIframe.nativeElement.src = iframeurl;

          this.examIframeComponent.examIframe.nativeElement.style.display = 'block';
          this.webcamAccessNotificationDivComponent.webcamAccessNotificationDiv.nativeElement.style.display = 'none';

        }
        else {
          console.log('No exam url found. Please contact the system administrator');
          alert('No exam url found. Please contact the system administrator');
          //examiframe.src = 'https://cbt.webtest.ng';
        }
      }
      catch (error) {
        console.error(error);
        this.examIframeComponent.examIframe.nativeElement.src = "";
        this.proctorStarted = false;
        
        // window.frames[0].postMessage({ type: 'proctorError', error: errorMessage }, '*');
        alert(error?.message || 'Error setting exam url');
      }
      finally{
        this.proctorStartClicked = false;
      }
    }
    else {
      this.proctorStarted = false;
      this.proctorStartClicked = false;
      console.error('company not set');
      this.toastr.error('company not set');
      //alert('company not set');
    }
  }
}


export enum ProctorLevels {
  RecordOnly = 'RecordOnly',
  AiProctoredOnly = 'AiProctoredOnly',
  LiveProctoredOnly = 'LiveProctoredOnly',
  LiveProctorWithAiAssist = 'LiveProctorWithAiAssist'
} 
